module.exports = __webpack_public_path__ + "static/media/p208ekran.0271547d.jpg";